import React from 'react';
import { getAccountScopeUserConfiguration } from 'mini-common-utils/lib/utils/getAccountScopeUserConfiguration';
import { PersonaControl } from 'owa-persona';
import { getAccountAvatarUrl } from '../utils/getAccountAvatarUrl';
import type { PersonaControlProps } from 'owa-persona';

export type UserPersonaControlProps = Omit<PersonaControlProps, 'name' | 'emailAddress'>;

export const UserPersonaControl = (props: UserPersonaControlProps) => {
    const { ...rest } = props;

    const {
        SessionSettings: { UserEmailAddress, UserDisplayName },
    } = getAccountScopeUserConfiguration();

    const imageUrl = getAccountAvatarUrl();

    return (
        <PersonaControl
            name={UserDisplayName}
            emailAddress={UserEmailAddress}
            imageUrl={imageUrl}
            {...rest}
        />
    );
};
